import * as React from 'react';
import { StringInput } from '../../../../commonv3/components/atoms/forms/primitive/StringInput';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { FieldStateV3 } from '../../../../commonv3/states/form/FormStateV3';
import './couponInputForm.module.scss';
import { observer } from 'mobx-react';

type Props = {
    couponCodeField: FieldStateV3<string>;
    onSubmit: () => any;
    submitting: boolean;
};

export const CouponInputForm = observer(({ couponCodeField, submitting, onSubmit }: Props) => (
    <div styleName="coupon-input-form">
        <div styleName="text">クーポンをお持ちの場合は入力してください</div>
        <div>
            <div styleName="coupon-input-wrapper">
                <StringInput
                    id="coupon-input"
                    styleName="coupon-input"
                    value={couponCodeField.getDirtyValue() || ''}
                    onChange={couponCodeField.setDirtyValue}
                    error={couponCodeField.hasErrors()}
                    placeholder="例)AABBYYZZ"
                />
                <Button
                    id="apply-coupon-submit"
                    styleName="submit-button"
                    type="primary"
                    size="m"
                    loading={submitting}
                    onClick={onSubmit}
                >
                    適応
                </Button>
            </div>
            {couponCodeField.hasErrors() && <div styleName="error">{couponCodeField.getErrors()[0]}</div>}
        </div>
    </div>
));
